/* unplugin-vue-components disabled */import { render } from "./ProReportShangTong.vue?vue&type=template&id=db7f0460&scoped=true&ts=true"
import script from "./ProReportShangTong.vue?vue&type=script&lang=ts"
export * from "./ProReportShangTong.vue?vue&type=script&lang=ts"

import "./ProReportShangTong.vue?vue&type=style&index=0&id=db7f0460&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db7f0460"]])

export default __exports__